"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationHelper = void 0;
const tslib_1 = require("tslib");
const AuthenticationHelper_1 = tslib_1.__importDefault(require("./AuthenticationHelper"));
exports.AuthenticationHelper = AuthenticationHelper_1.default;
